import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './styles/tokens.css';
import '@copilot/ui/styles.css';
import './styles/layout.css';
import './styles/admin.css';
import './components/common/common.css';
import './styles/accents.css';

import ErrorBoundary from './components/common/ErrorBoundary';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { initMonitoring } from './services/monitoring';

// Remote error reporting (services/monitoring.js): a no-op unless this
// build has REACT_APP_SENTRY_DSN. Before the first render.
initMonitoring();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <ThemeProvider>
      <AuthProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </AuthProvider>
    </ThemeProvider>
  </BrowserRouter>
);
